/**
 * Created by Greg on 4/4/2016.
 */
// import {netValidate} from './../../validation/netValid';
// import * as myNet from '../../netSamples/ExNetwithLoops1B.json';

let initialNet = {nodes: [], links: [], graph: {name:"", desc: ""}, directed: false, multigraph: false};
//netValidate(JSON.stringify(myNet)).netObj;

export default function net(state = initialNet, action) {
    switch (action.type) {
        case 'NET_LINK_EDIT':
        case 'NET_NODE_EDIT':
        case 'UPDATE_LINK_CAPACITIES':
        case 'UPDATE_LINK_WEIGHTS':
        case 'UPDATE_PORT_NUMBERS':
        case 'IPV4_ADDRESS_UPDATE':
        case 'NODE_LINK_DEL':
        case 'CHANGE_NET':
        case 'LOAD_NET':
            return Object.assign({}, action.net);
        case 'NET_NODE_ADD':
            return Object.assign({}, state, {nodes: state.nodes.concat(action.node)});
        case 'NET_LINK_ADD':
            return Object.assign({}, state, {links: state.links.concat(action.link)});
        case 'NEW_NET':
            return {nodes: [], links: [], graph: {name:"", desc: ""}, directed: false, multigraph: false};
        case  'NAME_DESC_CHANGE':
            return Object.assign({}, state, {graph: {name: action.name, desc: action.desc}});
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/netReducer.js